/* tslint:disable */
import { MeshPosition } from './mesh-position';

/**
 */
export class ViewMeshPosition {
    axis1?: MeshPosition;
    axis2?: MeshPosition;
    axis3?: MeshPosition;
}



// WEBPACK FOOTER //
// /home/dfm/cryosoft/ui/src/app/api/models/view-mesh-position.ts